/** Labelled block in the editor's left column: a small uppercase caption, an
 *  optional action on the right of it, and the control underneath. Lived in the
 *  v1 editor until that was removed; the v2 signature picker uses it too. */
export function Field({
  label,
  right,
  children,
}: {
  label: React.ReactNode
  right?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between text-[10.5px] font-semibold uppercase tracking-widest text-grey5">
        <span>{label}</span>
        {right}
      </div>
      {children}
    </div>
  )
}
